<div class="mobile-service-menu ">
  <mat-sidenav-content class="mobile-open-service-sidebar">
    <button (click)="sidenav.open()" style="width: 40px; padding: 0px !important; border: 0px;" class="box-shadow">
      <div class="service-button-icon">
        <mat-icon style="width: 100%; height: 100%; " svgIcon="{{seletedService.ImageMenuSrc}}"></mat-icon>
      </div>
    </button>
  </mat-sidenav-content>
  <mat-sidenav #sidenav style="    background-color: #00000000 !important;" (keydown.escape)="sidenav.close();  "
    class="service-select-side-bar" disableClose>
    <div class="service-list-container">
      <button mat-button class="service-button-content {{seletedService.name + '-mobile-service-button'}}"
        (click)="sidenav.close()">
        <div class="service-button-content" (click)="[toggle(seletedService.id), sidenav.close()]">
          <div class="service-button-icon">
            <mat-icon style="width: 100%; height: 100%; " svgIcon="{{seletedService.ImageMenuSrc}}"></mat-icon>
          </div>
          <p>{{seletedService.menuTitle}}
          </p>
        </div>
      </button>
      <div *ngFor="let item of serviceList">
        <button mat-button *ngIf="item.id != seletedService.id"
          class="service-button-content {{item.name + '-mobile-service-button'}}" (click)="sidenav.close()">
          <div class="service-button-content" (click)="[toggle(item.id), sidenav.close()]">
            <div class="service-button-icon">
              <mat-icon color="primary" style="width: 100%; height: 100%; " svgIcon="{{item.ImageMenuSrc}}"></mat-icon>
            </div>

            <p>{{item.menuTitle }}</p>
          </div>
        </button>
      </div>
    </div>
  </mat-sidenav>

</div>
